import { render } from "./IconTwitter.vue?vue&type=template&id=3c55f985&scoped=true"
import script from "./IconTwitter.vue?vue&type=script&lang=js"
export * from "./IconTwitter.vue?vue&type=script&lang=js"

import "./IconTwitter.vue?vue&type=style&index=0&id=3c55f985&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c55f985"]])

export default __exports__